import { render, staticRenderFns } from "./camRecordDialog.vue?vue&type=template&id=66767933"
import script from "./camRecordDialog.vue?vue&type=script&lang=js"
export * from "./camRecordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports